import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';

const SortHeader = ({ label, field, sortField, sortDir, onSort }) => {
  const active = sortField === field;
  return (
    <th
      className="text-left text-xs uppercase tracking-wider text-[#5C6B63] font-semibold p-4 cursor-pointer select-none hover:bg-[#EDEAE3] transition-colors"
      onClick={() => onSort(field)}
      role="button"
      tabIndex={0}
      data-testid={`sort-header-${field}`}
    >
      <div className="flex items-center gap-1.5">
        {label}
        {active ? (
          sortDir === 'asc' ? <ArrowUp className="w-3.5 h-3.5 text-[#2C4A3B]" /> : <ArrowDown className="w-3.5 h-3.5 text-[#2C4A3B]" />
        ) : (
          <ArrowUpDown className="w-3.5 h-3.5 text-[#5C6B63]/40" />
        )}
      </div>
    </th>
  );
};

export default SortHeader;
